import { ReactNode } from "react";

import { Dots } from "components/icons/generated";
import ButtonIcon from "ds/components/ButtonIcon";
import DropdownMenu from "ds/components/DropdownMenu";

import styles from "../styles.module.css";

type TableHeadInteractiveColumnOptionsDropdownProps = {
  children: ReactNode;
};

const TableHeadInteractiveColumnOptionsDropdown = ({
  children,
}: TableHeadInteractiveColumnOptionsDropdownProps) => {
  return (
    <DropdownMenu
      triggerComponent={
        <ButtonIcon className={styles.columnDropdownEllipsis} icon={Dots} variant="ghost">
          Column options
        </ButtonIcon>
      }
    >
      {children}
    </DropdownMenu>
  );
};

TableHeadInteractiveColumnOptionsDropdown.displayName =
  "DS.Table.Head.InteractiveColumn.Options.Dropdown";

export default TableHeadInteractiveColumnOptionsDropdown;
